import { createReducer, on } from '@ngrx/store';
import { ManageCartsActions } from '../actions';
import { ManageCartsInfo } from '../state/cart-details.state';

export const initialState: ManageCartsInfo = {
  loading: null,
  error: null,
  success: null,
  manageCartsData: null,
  columns: [],
  legalEntityFilterData: null,
  errorMessage: null,
  //data that is used across cart application: sharedCartData
  sharedCartData: null,
};

export const saveCartReducer = createReducer(
  initialState,

  // Handle Combined api call response in loadManageCartsDataWithFilterSuccess action
  on(
    ManageCartsActions.loadManageCartsDataWithFilterSuccess,
    (state: ManageCartsInfo, { legalEntitiesPayload, savedCartsPayload }): ManageCartsInfo => ({
      ...state,
      ...savedCartsPayload,
      loading: false,
      success: true,
      error: null,
      legalEntityFilterData: {
        ...state.legalEntityFilterData,
        filterData: legalEntitiesPayload,
        error: null
      }
    })
  ),

  // Handle Combined api call failure loadManageCartsDataWithFilterFailure action
  on(
    ManageCartsActions.loadManageCartsDataWithFilterFailure,
    (state: ManageCartsInfo, { error }) => ({
      ...state,
      loading: false,
      success: false,
      error: error,
    })
  ),

  // Reducer call to get the list of all saved-carts in the saved-carts page
  on(
    ManageCartsActions.loadManageCartsSuccess,
    (state: ManageCartsInfo, { payload }): ManageCartsInfo => ({
      ...state,
      ...payload,
      loading: false,
      success: true,
      error: null,
    })
  ),
  on(
    ManageCartsActions.loadManageCartsFailure,
    (state: ManageCartsInfo, { error }): ManageCartsInfo => ({
      ...state,
      loading: false,
      success: false,
      error: error,
    })
  ),

  on(
    ManageCartsActions.setErrorMessage,
    (state: ManageCartsInfo, { errorMessage }): ManageCartsInfo => ({
      ...state,
      errorMessage
    })
  ),
  //Below are Common Reducers that are used in service files(global.service.ts file) and multiple components
  //cart.component.ts, cart-selector.component.ts, add-to-cart.component.ts, number-input-template.component.ts
  //pages name: cartpage, mini cart , saved carts

  // CARTS UPDATED TRUE OR FALSE
  on(
    ManageCartsActions.updateCartStatus,
    (state: ManageCartsInfo, { status }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        updateCartStatus: status,
      },
      error: null
    })
  ),

  // To check manageCartsPaginationReset in the Global service
  on(
    ManageCartsActions.resetPagination,
    (state: ManageCartsInfo, { reset }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        manageCartsPaginationReset: reset
      },
      error: null
    })
  ),

  // varaiables that are used in global service ts are converted to use store
  on(
    ManageCartsActions.setManageCartsSortFlag,
    (state: ManageCartsInfo, { manageCartsSortFlagData }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        manageCartsSortFlag: manageCartsSortFlagData
      },
      error: null
    })
  ),
  on(
    ManageCartsActions.setSaveCartsFilter,
    (state: ManageCartsInfo, { saveCartsFilterData }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        saveCartsFilter: saveCartsFilterData
      },
      error: null
    })
  ),
  on(
    ManageCartsActions.setSaveCartsSort,
    (state: ManageCartsInfo, { saveCartsSortData }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        saveCartsSort: saveCartsSortData
      },
      error: null
    })
  ),
  // For Duplicate cart Index
  on(
    ManageCartsActions.setDuplicateCartIndex,
    (state: ManageCartsInfo, { index }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        duplicateCartIndex: index
      },
      error: null
    })
  ),
  // For Delete cart Index
  on(
    ManageCartsActions.setDeleteCartIndex,
    (state: ManageCartsInfo, { index }): ManageCartsInfo => ({
      ...state,
      sharedCartData: {
        ...state.sharedCartData,
        deleteCartIndex: index
      },
      error: null
    })
  ),
);